export const pinata_api_key = "dc3dab55e52b6f561188";
export const pinata_secret_api_key =
  "403cbae03f8c6346fa1c78096d83960269b1baa90d50ba7b6f94a387d7bc959a";
export const pinJSONToIPFS = "https://api.pinata.cloud/pinning/pinJSONToIPFS";
export const pinFileToIPFS = "https://api.pinata.cloud/pinning/pinFileToIPFS";
